import './styles/base.css';
import './styles/sections.css';

import useSiteMotion from './hooks/useSiteMotion';
import Backdrop from './components/Backdrop';
import Nav from './components/Nav';
import Hero from './components/Hero';
import SectionRule from './components/SectionRule';
import Walkthrough from './components/Walkthrough';
import TableOrdering from './components/TableOrdering';
import AISection from './components/AISection';
import Mobile from './components/Mobile';
import Features from './components/Features';
import Hotel from './components/Hotel';
import CarOrdering from './components/CarOrdering';
import HowItWorks from './components/HowItWorks';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function App() {
  useSiteMotion();

  return (
    <>
      <Backdrop />
      <Nav />
      <Hero />

      <SectionRule number="01" label="The Console" />
      <Walkthrough />

      <SectionRule number="02" label="Table Ordering" />
      <TableOrdering />

      <SectionRule number="03" label="The Guest App" />
      <Mobile />

      <SectionRule number="04" label="Capabilities" />
      <Features />

      <SectionRule number="05" label="How it works" />
      <HowItWorks />

      <SectionRule number="06" label="Intelligence" />
      <AISection />

      <SectionRule number="07" label="Car / Counter Ordering" />
      <CarOrdering />

      <SectionRule number="08" label="Hospitality" />
      <Hotel />

      <SectionRule number="09" label="Request Access" />
      <CTA />
      <Footer />
    </>
  );
}
